/**
 * Time unit associated with the interval to the first (and possibly only) exercise date in the exercise period.
 * tag: 40126
 * @readonly
 * @enum {string} (String)
 */
export enum ProvisionOptionExerciseEarliestDateOffsetUnit {
  /** Day */
  Day = 'D',
  /** Week */
  Week = 'Wk',
  /** Month */
  Month = 'Mo',
  /** Year */
  Year = 'Yr',
}
